var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12655_74123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.73907 16.7599L3.73774 16.7504L3.73604 16.741L1.63476 5.07906C1.63257 5.05284 1.63073 5.02914 1.62926 5.0075C1.69942 5.00256 1.79281 4.99988 1.91805 4.99988H16.082C16.207 4.99988 16.3004 5.00243 16.3707 5.00722C16.3692 5.02899 16.3674 5.05285 16.3652 5.07921L14.2636 16.741L14.2619 16.7504L14.2606 16.7599L14.2563 16.7904C14.2156 17.0798 14.1895 17.2651 14.1249 17.3959C14.099 17.4486 14.078 17.4657 14.067 17.4728C14.0573 17.4791 14.021 17.5 13.9239 17.5H4.07574C3.97864 17.5 3.94239 17.4791 3.93264 17.4728C3.92162 17.4657 3.90071 17.4486 3.87473 17.3959C3.81018 17.2651 3.7841 17.0799 3.74337 16.7904L3.73907 16.7599ZM1.48895 5.02698C1.48893 5.02697 1.48941 5.02679 1.49043 5.02647L1.48895 5.02698ZM16.5129 5.02653C16.5129 5.02654 16.5124 5.02638 16.5114 5.02602L16.5129 5.02653Z",
    stroke: "#303030"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.00312,
    y: 8.24979,
    width: 0.50625,
    height: 5.44296,
    rx: 0.253125,
    fill: "#344868",
    stroke: "#303030",
    strokeWidth: 0.50625
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.3781,
    y: 8.24979,
    width: 0.50625,
    height: 5.44296,
    rx: 0.253125,
    fill: "#344868",
    stroke: "#303030",
    strokeWidth: 0.50625
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_12655_74123",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 2.50144C0 2.22534 0.223828 2.00151 0.499934 2.00151H17.5001C17.7762 2.00151 18 2.22534 18 2.50144C18 2.77755 17.7762 3.00138 17.5001 3.00138H0.499934C0.223828 3.00138 0 2.77755 0 2.50144Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M0 2.50144C0 2.22534 0.223828 2.00151 0.499934 2.00151H17.5001C17.7762 2.00151 18 2.22534 18 2.50144C18 2.77755 17.7762 3.00138 17.5001 3.00138H0.499934C0.223828 3.00138 0 2.77755 0 2.50144Z",
    fill: "#344868"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.499934 3.00151H17.5001V1.00151H0.499934V3.00151ZM17.5001 2.00138H0.499934V4.00138H17.5001V2.00138ZM0.499934 2.00138C0.776113 2.00138 1 2.22527 1 2.50144H-1C-1 3.32983 -0.328457 4.00138 0.499934 4.00138V2.00138ZM17 2.50144C17 2.22527 17.2239 2.00138 17.5001 2.00138V4.00138C18.3285 4.00138 19 3.32984 19 2.50144H17ZM17.5001 3.00151C17.2239 3.00151 17 2.77762 17 2.50144H19C19 1.67305 18.3285 1.00151 17.5001 1.00151V3.00151ZM0.499934 1.00151C-0.328456 1.00151 -1 1.67305 -1 2.50144H1C1 2.77762 0.776112 3.00151 0.499934 3.00151V1.00151Z",
    fill: "#303030",
    mask: "url(#path-4-inside-1_12655_74123)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.875,
    y: 0.5,
    width: 10.25,
    height: 1.9996,
    rx: 0.999801,
    stroke: "#303030"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12655_74123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.b2ff925ca56403a8c24b6c527a8a41e8.svg";
export { ForwardRef as ReactComponent };